import type { ReactElement } from 'react'
import { NotReady } from '@components'
import { useProfile } from '@front/model'
import type { CompanyData, TeamId } from '@terros/common'
import { parseAsTeamId } from '@util'
import { useQueryState } from 'nuqs'
import { PreferencesPage } from './PreferencesPage'
import { createFileRoute } from '@tanstack/react-router'

function Configuration(): ReactElement {
  const { user, company, isLoading, error } = useProfile()
  if (isLoading || error || !company) return <NotReady data={user} error={error} id='Company' isLoading={isLoading} />
  return <PreferencesWithCompanyAndUser company={company} />
}

type Props = {
  company: CompanyData
}

const PreferencesWithCompanyAndUser = ({ company }: Props): ReactElement => {
  const [teamId, setTeamId] = useQueryState<TeamId>('teamId', parseAsTeamId)
  const scopeId = teamId ?? company.companyId

  return (
    <PreferencesPage
      emptyLabel={company.name}
      scopeId={scopeId}
      setTeamId={(t) => {
        setTeamId(t ?? null)
      }}
    />
  )
}

export const Route = createFileRoute('/settings/configuration/')({
  component: Configuration,
})
